// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about","852":"orders"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"110a2d06","179":"fddcb241","207":"ca6c1647","330":"90563d01","594":"d4d4ceac","852":"b6c94780"}[chunkId] + ".js";
};